export function normalizedChangeValue(value: unknown): string {
  return String(value ?? '').trim();
}

export function isVisibleFieldChange(fieldChanges: {
  originalAndLastUpdated?: { oldValue?: unknown; newValue?: unknown };
}): boolean {
  const pair = fieldChanges.originalAndLastUpdated;
  if (!pair) return false;
  return (
    normalizedChangeValue(pair.oldValue) !==
    normalizedChangeValue(pair.newValue)
  );
}
